export const aboutData = {
  brand: {
    title: '关于狼友域名',
    intro: '狼友域名成立于2024年，是专为站长和资源爱好者打造的专业域名导航与资源聚合平台。我们致力于解决用户在日常使用中遇到的域名访问困难问题，通过提供多线路域名导航、实时状态监控和备用入口推荐，帮助用户始终保持稳定畅通的访问体验。',
    mission: '我们的使命是让每一位用户都能轻松找到稳定可用的域名入口，告别域名失联带来的困扰。通过持续的技术创新和服务优化，狼友域名已成为业内领先的域名导航平台。',
    vision: '成为最值得信赖的域名导航服务品牌，构建覆盖全网的高质量资源导航生态。',
    values: [
      { title: '稳定可靠', description: '多节点部署，实时监控域名状态，确保服务稳定运行' },
      { title: '用户至上', description: '以用户需求为核心，持续优化产品体验和服务质量' },
      { title: '开放共享', description: '倡导资源共享理念，构建互帮互助的用户社区' },
      { title: '技术创新', description: '持续投入技术研发，探索更安全稳定的域名服务方案' },
    ],
  },
  stats: [
    { label: '收录域名', value: '200+', icon: 'ri-global-line' },
    { label: '服务用户', value: '50,000+', icon: 'ri-user-line' },
    { label: '日均访问', value: '100,000+', icon: 'ri-bar-chart-line' },
    { label: '在线率', value: '99.9%', icon: 'ri-check-double-line' },
  ],
  reputation: [
    {
      name: '张先生',
      role: '资深站长',
      content: '狼友域名是我用过最专业的域名导航平台，收录的域名地址准确率高，更新速度快。特别是防失联功能非常好用，再也不用担心找不到入口了。强烈推荐给所有站长朋友！',
      rating: 5,
    },
    {
      name: '李女士',
      role: '资源爱好者',
      content: '自从用了狼友域名，再也没遇到过找不到资源站点的情况。多个备用入口的设计很贴心，收藏了这个导航页后就再没失联过，非常满意！',
      rating: 5,
    },
    {
      name: '王先生',
      role: '网络工程师',
      content: '从技术角度看，狼友域名的架构设计非常专业。多线路冗余、智能DNS解析、CDN加速等技术的应用，确实保障了平台的高可用性。作为同行，我对这个产品非常认可。',
      rating: 5,
    },
    {
      name: '赵先生',
      role: '自媒体运营',
      content: '做自媒体经常需要访问各种资源站点收集素材，狼友域名帮我节省了大量时间。域名状态实时显示的功能特别实用，一眼就能看出哪些域名可用。',
      rating: 5,
    },
    {
      name: '陈女士',
      role: '自由职业者',
      content: '朋友推荐的狼友域名，用了一段时间确实很好。界面简洁清晰，分类明确，找域名很方便。已经推荐给了好几个同事，大家都说好用。',
      rating: 5,
    },
    {
      name: '刘先生',
      role: 'IT从业者',
      content: '狼友域名不仅提供域名导航，还有丰富的技术文章和使用指南，对提升网络安全意识很有帮助。平台的专业性和服务态度都值得称赞。',
      rating: 4,
    },
  ],
  faqs: [
    {
      question: '狼友域名是什么？',
      answer: '狼友域名是一个专业的域名导航与资源聚合平台，为站长和资源爱好者提供最新可用域名地址、镜像备用链接及防失联入口服务。我们实时更新域名状态，帮助用户快速找到稳定可访问的域名入口。',
    },
    {
      question: '如何获取狼友域名最新地址？',
      answer: '您可以通过以下方式获取狼友域名最新地址：1）收藏本导航页面，我们会实时更新所有可用域名；2）关注我们的官方社交媒体账号获取更新通知；3）将防失联永久入口加入书签，该地址长期有效不变。',
    },
    {
      question: '什么是镜像域名？如何使用？',
      answer: '镜像域名是主站点的完整复制，部署在不同的服务器上。当主域名访问缓慢或暂时无法访问时，您可以选择镜像域名获得相同的服务体验。镜像域名与主站数据实时同步，无需担心内容差异。',
    },
    {
      question: '备用入口和主域名有什么区别？',
      answer: '备用入口和主域名提供完全相同的服务内容，只是部署在不同的服务器和网络环境中。备用入口的主要作用是当主域名出现访问问题时，提供替代访问通道。建议用户同时收藏多个备用入口，增强访问保障。',
    },
    {
      question: '防失联域名真的不会变更吗？',
      answer: '防失联域名是我们在现有技术条件下能够提供的最稳定入口。虽然我们无法百分之百保证域名永不变更，但我们承诺在任何变更前都会提前通知用户，并确保新旧地址在一段时间内同时有效，给用户充分的过渡时间。',
    },
    {
      question: '域名显示离线怎么办？',
      answer: '如果某个域名显示离线状态，建议您：1）尝试使用其他可用的镜像域名或备用入口；2）检查您的网络连接是否正常；3）等待几分钟后重试，部分离线可能是临时维护；4）如长时间离线，可联系我们的客服获取最新可用域名信息。',
    },
  ],
  contact: {
    email: 'contact@langyouyuming.com',
    wechat: 'langyouyuming',
    qq: '88886666',
    telegram: '@langyouyuming',
    response: '我们会在24小时内回复您的咨询。对于紧急域名访问问题，建议优先查看我们的备用入口和防失联域名。',
  },
};